import { useState } from "react";
import { toast } from "sonner";
import { MonitorPlay, Pencil, Save, X } from "lucide-react";
import { api } from "@/lib/api";
import { InfoCard } from "./InfoBits";

export const PLAYER_FIELDS = [
  ["funplay", "Fun Play"], ["playsim", "Play Sim"], ["hdplayer", "HD Player"], ["lazerplay", "Lazer Play"],
  ["zuxo", "Zuxo Player"], ["duplecast_id", "Duplecast · Device ID"], ["duplecast_key", "Duplecast · Device Key"],
];
const isMac = (k) => !k.startsWith("duplecast");
const fmtMac = (v) => (v || "").replace(/[^0-9a-fA-F]/g, "").toUpperCase().slice(0, 12).match(/.{1,2}/g)?.join(":") || "";
const valid = (k, v) => !v || !isMac(k) || /^([0-9A-F]{2}:){5}[0-9A-F]{2}$/.test(v);

export const PlayerMacsCard = ({ c, onSaved }) => {
  const [edit, setEdit] = useState(false);
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);
  const pm = c.player_macs || {};
  const bad = PLAYER_FIELDS.some(([k]) => !valid(k, form[k]));
  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/clients/${c.id}/player-macs`, { player_macs: form });
      toast.success("MACs dos apps salvos");
      setEdit(false);
      onSaved();
    } catch (e) { toast.error(e.response?.data?.detail || "Falha ao salvar"); }
    setBusy(false);
  };
  return (
    <InfoCard testid="card-player-macs" title="Apps da TV (MAC)" icon={MonitorPlay} color="#22D3EE">
      {PLAYER_FIELDS.map(([k, label]) => (
        <div key={k} className="min-w-0">
          <div className="text-[11px] uppercase tracking-wider text-slate-500">{label}</div>
          {edit
            ? <input data-testid={`player-mac-input-${k}`} value={form[k] || ""} placeholder={isMac(k) ? "00:00:00:00:00:00" : ""}
                onChange={(e) => setForm({ ...form, [k]: isMac(k) ? fmtMac(e.target.value) : e.target.value })}
                className={`mt-0.5 w-full rounded-md border bg-[#0B1019] px-2 py-1 font-mono text-sm text-white outline-none focus:border-cyan-500 ${valid(k, form[k]) ? "border-[#202D45]" : "border-red-500"}`} />
            : <div data-testid={`player-mac-value-${k}`} className={`mt-0.5 break-all font-mono text-sm ${pm[k] ? "text-white" : "text-slate-600"}`}>{pm[k] || "—"}</div>}
        </div>
      ))}
      <div className="col-span-2 mt-1 flex gap-2">
        {edit ? (
          <>
            <button data-testid="player-mac-save-btn" disabled={busy || bad} onClick={save}
              className="inline-flex flex-1 items-center justify-center gap-2 rounded-lg bg-cyan-400 px-3 py-2 text-xs font-bold text-slate-950 transition-opacity hover:opacity-90 disabled:opacity-40">
              <Save className="h-4 w-4" /> {bad ? "MAC incompleto" : "Salvar"}
            </button>
            <button data-testid="player-mac-cancel-btn" onClick={() => setEdit(false)}
              className="inline-flex items-center justify-center gap-2 rounded-lg border border-[#202D45] px-3 py-2 text-xs font-semibold text-slate-300 hover:bg-[#1A2234]">
              <X className="h-4 w-4" /> Cancelar
            </button>
          </>
        ) : (
          <button data-testid="player-mac-edit-btn" onClick={() => { setForm({ ...pm }); setEdit(true); }}
            className="inline-flex flex-1 items-center justify-center gap-2 rounded-lg border border-cyan-400/40 bg-cyan-400/10 px-3 py-2 text-xs font-bold text-cyan-200 transition-colors hover:bg-cyan-400/20">
            <Pencil className="h-4 w-4" /> Editar MACs dos apps
          </button>
        )}
      </div>
    </InfoCard>
  );
};
